import { useEffect, useMemo, useState } from 'react';
import { IWeeklyTimeline } from '../../timelineItem';
import BasicCard from '../../../../components/basicCard/BasicCard';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Spanish
import 'dayjs/locale/en'; // English

import localizedFormat from 'dayjs/plugin/localizedFormat';
import weekday from 'dayjs/plugin/weekday';
import utc from 'dayjs/plugin/utc';

import { useTranslation } from 'react-i18next';
import WeeklyInspectionItem from './WeeklyInspectionItem';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import { getWeeklyData } from '../../getData';
import { useNotificationContext } from '../../../../contexts/NotificationContext';

dayjs.extend(localizedFormat);
dayjs.extend(weekday);
dayjs.extend(utc);

// const weeklyItems: any = {
//   '[1757808000000, 1758412799999]': {
//     '1758240000000': [
//       {
//         establishment: 'Paiz',
//         location: 'Choluteca, Choluteca',
//         establishmentType: 'Supermercados',
//         numberOfProducts: 2,
//         status: 'completed',
//         priority: 'medium',
//         assignees: ['95800cb9-1dd3-495d-aa34-07bb9c2d06d3'],
//         establishmentId: 3,
//         basketId: [],
//         locationId: 10,
//         refId: 'task_1ebc5159-45ae-4568-800e-ad000d238b7f',
//         productId: [
//           'product_adec869b-d6dd-49f6-9649-f9e861469a72',
//           'product_d5a4cf67-e6fc-4090-818b-6a93215a0553',
//         ],
//         taskName: 'Price inspection 01',
//       },
//       {
//         establishment: 'Wal Mart',
//         location: 'Arizona, Atlántida',
//         establishmentType: 'Supermercados',
//         numberOfProducts: 3,
//         status: 'completed',
//         priority: 'low',
//         assignees: ['ef0a45f3-73ae-49e5-adf7-4441467f5795'],
//         establishmentId: 7,
//         basketId: [],
//         locationId: 1,
//         refId: 'task_c26d2e55-52a6-4526-8a0f-92137db9d5b1',
//         productId: [
//           'product_7e72ce8c-b7ee-4899-96f6-39fa4138c304',
//           'product_8c883922-1a12-43a4-bab5-58bb59f0d0fc',
//           'product_f29dcb7d-74fd-43bd-af29-3c764f41af47',
//         ],
//         taskName: 'MeatPrice',
//       },
//       {
//         establishment: 'Wal Mart',
//         location: 'Arizona, Atlántida',
//         establishmentType: 'Supermercados',
//         numberOfProducts: 2,
//         status: 'in_progress',
//         priority: 'high',
//         assignees: [
//           '95800cb9-1dd3-495d-aa34-07bb9c2d06d3',
//           '47b58c2c-c075-4ecb-b9fb-ed4d1461f76b',
//           '986a5d0d-40d8-425c-a6e3-5e8e28a26e3d',
//           'ef0a45f3-73ae-49e5-adf7-4441467f5795',
//         ],
//         establishmentId: 7,
//         basketId: [],
//         locationId: 1,
//         refId: 'task_66b40780-d46f-4877-8ed7-960dcbbb1bff',
//         productId: [
//           'product_58041c66-8066-46f9-8687-51cfb585e584',
//           'product_cef61736-a1a5-4952-9803-7f738ad2fa0c',
//         ],
//         taskName: 'Fruit Inspection',
//       },
//       {
//         establishment: 'The Pantry',
//         location: 'Cedros, Francisco Morazán',
//         establishmentType: 'Supermercados',
//         numberOfProducts: 1,
//         status: 'in_progress',
//         priority: 'medium',
//         assignees: ['ef0a45f3-73ae-49e5-adf7-4441467f5795'],
//         establishmentId: 4,
//         basketId: [],
//         locationId: 111,
//         refId: 'task_44733eca-3972-4347-9eff-ab8f77725573',
//         productId: ['product_8c883922-1a12-43a4-bab5-58bb59f0d0fc'],
//         taskName: 'Fish inspection',
//       },
//     ],
//   },
// };

const notifications = [
  {
    title: 'Time change',
    message: 'Los Dolores Market - New schedule: 8:30 AM',
  },
  {
    title: 'Priority Product',
    message: 'Check plant oil prices in all establishments',
  },
];

const WeeklyView = () => {
  const [count, setCount] = useState<number>(0);

  const { errorNotification } = useNotificationContext();

  const [startOfWeek, setStartOfWeek] = useState(dayjs().utc().startOf('week'));
  const [endOfWeek, setEndOfWeek] = useState(dayjs().utc().endOf('week'));

  const [weeklyData, setWeeklyData] = useState<IWeeklyTimeline>();

  useEffect(() => {
    const tempStartOfWeek = dayjs().add(count, 'week').startOf('week');
    const tempEndOfWeek = dayjs().add(count, 'week').endOf('week');
    setStartOfWeek(tempStartOfWeek);
    setEndOfWeek(tempEndOfWeek);

    const getWeeklyDataWrapper = async () => {
      try {
        const data = await getWeeklyData(tempStartOfWeek.valueOf(), tempEndOfWeek.valueOf());
        // const data = weeklyItems;

        const dataWithNewKeys: any = {};
        if (data) {
          const tempData = data[Object.keys(data)[0]];
          if (tempData) {
            const prevKeys = Object.keys(tempData);
            prevKeys.forEach((key: string) => {
              const newKey = dayjs(Number(key)).utc().format('D-MM');
              dataWithNewKeys[newKey] = tempData[key];
            });
          }
        }
        setWeeklyData(dataWithNewKeys);
      } catch (error: any) {}
    };

    getWeeklyDataWrapper();
  }, [count]);

  const { t } = useTranslation('inspector');

  const weekdays = useMemo(() => {
    const sunday = startOfWeek;
    return Array.from({ length: 7 }, (_, i) => sunday.add(i, 'day'));
  }, [startOfWeek]);

  return (
    <div className="mb-6 mt-16">
      <div className="h-fit">
        <BasicCard radius="md">
          <div className="p-4">
            <div className="my-4 flex flex-col justify-between gap-4 md:flex-row">
              <div>
                <div className="flex flex-row items-center gap-3">
                  <FaChevronLeft
                    className="transition-colors hover:cursor-pointer hover:text-primary"
                    onClick={() => setCount((prev) => prev - 1)}
                  />
                  <h3 className="text-center text-xl font-semibold leading-none tracking-tight md:text-2xl">
                    {t('timelineHeading', {
                      startOfWeek: startOfWeek.format('D'),
                      endOfWeekWithMonthYear: endOfWeek.format('D MMMM YYYY'),
                    })}
                  </h3>
                  <FaChevronRight
                    className="transition-colors hover:cursor-pointer hover:text-primary"
                    onClick={() => setCount((prev) => prev + 1)}
                  />
                </div>
                <p className="my-4 ml-0 text-center text-sm md:ml-8 md:text-left">
                  {t('detailedTimeOfInspections')}
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-6">
              {weekdays.map((weekday: any, index: number) => {
                const tempWeeklyData = weeklyData ? weeklyData[String(weekday.format('D-MM'))] : [];
                return (
                  <div
                    className="border-l-[3px] border-l-primary px-2 md:px-6"
                    key={index + Date.now()}
                  >
                    <div className="mb-4 flex flex-row items-center justify-between">
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900">
                          {t(`day${weekday.day() + 1}`)}
                        </h3>
                        <p className="text-sm text-gray-600">{weekday.format('D MMMM')}</p>
                      </div>

                      <span className="mt-4 inline-flex rounded-full border bg-gray-50 px-2.5 py-0.5 text-xs font-semibold capitalize">
                        {t('noOfTasks', {
                          count: tempWeeklyData ? tempWeeklyData.length : 0,
                        })}
                      </span>
                    </div>

                    <div className="flex flex-col gap-4 md:gap-3">
                      {tempWeeklyData &&
                        tempWeeklyData.map((item) => (
                          <WeeklyInspectionItem
                            priority={item?.priority}
                            establishment={item?.establishment}
                            location={item?.location}
                            establishmentType={item?.establishmentType}
                            numberOfProducts={item?.numberOfProducts}
                            status={item?.status}
                            assignees={item?.assignees}
                            establishmentId={item?.establishmentId}
                            basketId={item?.basketId}
                            locationId={item?.locationId}
                            refId={item?.refId}
                            productId={item?.productId}
                            taskName={item?.taskName}
                            taskTypeKey={item?.taskTypeKey}
                            subTaskTypeKey={item?.subTaskTypeKey}
                            fuelStationName={item?.fuelStationName}
                          />
                        ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </BasicCard>
      </div>
    </div>
  );
};

export default WeeklyView;
